import { useMutation } from '@tanstack/react-query'
import { apiClient } from '@shared/api/client'
import { endpoints } from '@shared/api/endpoints'
import {
  classifyModerationError,
  isKnownModerationError,
  ModerationErrorKind,
} from '../lib/moderationError'
import { useNotificationsUi } from '../model/provider'
import { NotificationStatus } from '../model/types'

/** Два известных отказа объясняет сама карточка — общий тост для них молчит. */
function useModerationErrorHandler() {
  const { setModerationIssue } = useNotificationsUi()
  return (error: unknown, id: number) => {
    const kind = classifyModerationError(error)
    if (kind !== ModerationErrorKind.other) setModerationIssue(id, kind)
  }
}

export function useApproveNotification() {
  const { resolveNotification } = useNotificationsUi()
  const onModerationError = useModerationErrorHandler()
  return useMutation({
    mutationFn: (id: number) => apiClient.post(endpoints.notifications.approve(id)),
    onSuccess: (_data, id) => resolveNotification(id, NotificationStatus.approved),
    onError: (error, id) => onModerationError(error, id),
    meta: { silentWhen: isKnownModerationError },
  })
}

export function useDeclineNotification() {
  const { resolveNotification } = useNotificationsUi()
  const onModerationError = useModerationErrorHandler()
  return useMutation({
    mutationFn: (id: number) => apiClient.post(endpoints.notifications.decline(id)),
    onSuccess: (_data, id) => resolveNotification(id, NotificationStatus.declined),
    onError: (error, id) => onModerationError(error, id),
    meta: { silentWhen: isKnownModerationError },
  })
}
